import { useState, useEffect } from 'react';

interface ViewportHeightInfo {
  vh: number;
  upperSectionHeight: number;
  lowerSectionHeight: number;
  singleLayerHeight: number;
}

export const useViewportHeight = (): ViewportHeightInfo => {
  const [vh, setVh] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    vh,
    // 上层区域高度：60%视窗减去header和padding (120px)
    upperSectionHeight: Math.floor(vh * 0.6 - 120),
    // 下层区域高度：40%视窗减去padding (60px)
    lowerSectionHeight: Math.floor(vh * 0.4 - 60),
    // 单层布局高度：全高度减去header和padding (180px)
    singleLayerHeight: Math.floor(vh - 180),
  };
};